import type { ChecklistRequirement } from '@ifs-gcp/core';
import type { ChecklistChild, FilterTypes, TranslationText } from '@ifs-gcp/core/models';

import { getTranslation } from '@/utils/translations';

import type { DropdownItem } from './checklist';

export type BaseFilterableTableColumn = {
  id: string;
  minWidth?: number;
  width?: 'fill' | number;
  label: string;
  disabled?: boolean;
  filterOptionId?: FilterTypes | null;
  filters?: DropdownItem<string>[];
  isColumnFiltered: boolean;
};

export const processColumnToFilter =
  (templateRow: ChecklistRequirement) => (column: BaseFilterableTableColumn) => {
    const { score } = templateRow;

    const { filters: columnFilters = [], filterOptionId } = column;

    /**
     * Check if column even has filters. If not, filtering is skipped for that column
     */
    if (!filterOptionId) {
      return true;
    }

    /**
     * Check if column has touched filters. Touched filter is the one with `isActive` set to false
     * If not, we do not filter anything
     */
    const activeColumnFilters = columnFilters.filter(({ isActive }) => isActive);

    if (!activeColumnFilters.length) {
      return true;
    }

    if (filterOptionId === 'scoreFilterOption') {
      if (column.id === 'requirementScore') {
        return activeColumnFilters.some(({ value }) => value === (score?.scoreId || 'empty'));
      }
    }

    return false;
  };

type TableColumnFilter = {
  label: string;
  value: string | number;
  isActive: boolean;
};

export const mapFilterId = (
  translations: Record<string, TranslationText>,
  filterId: FilterTypes | null,
  availableScores: ChecklistChild['props']['availableScores'],
  language: string,
): TableColumnFilter[] => {
  if (filterId === 'scoreFilterOption' && availableScores) {
    return [
      ...Object.values(availableScores).map(({ id, text }) => {
        return {
          isActive: false,
          label: getTranslation(text, language),
          value: id,
        };
      }),
      {
        isActive: false,
        label: getTranslation(translations.empty, language),
        value: 'empty',
      },
    ];
  }

  return [];
};
